<ng-container 
[ngTemplateOutlet]="enableNewInvoiceDisplay? newUiDisplay : existingUiDisplay" 
>
</ng-container>

<ng-template #newUiDisplay>
    <p class="no-results"></p>
    <div class="pb-4" *ngIf="invoiceData.length === 0" i18n="@@documents.accountInvoicesNoInvoices">
      There are no invoices
    </div>

    <div class="card h-100" *ngIf="invoiceData.length !== 0 ">
      <div class="card-body">
      <table class="table">
          <thead>
              <tr>
                  <th class="pl-3 align-middle">
                    Month
                    <a [ngClass]="'fa-angle-up'"
                    ></a>
                  </th>
                  <th class="pl-3 align-middle"> Invoice # </th>
                  <th class="pl-3 align-middle"> Amount </th>
                  <th class="pl-3 align-middle"> Download Link </th>
              </tr>
          </thead>    

          <tbody>
              <tr *ngFor="let invoice of invoiceData">
                <td class="pl-3 align-middle">
                  {{ invoice.InvoiceDate | reefDate: 'MMM YYYY' }}
                </td>
                
                <td class="pl-3 align-middle">
                    {{ invoice.InvoiceNumber }}
                </td>

                <td class="pl-3 align-middle">
                  {{ !invoice.InvoiceNumber ? ' ': invoice.CurrentCharges | reefCurrency: currency }}
                </td>

                <td>
                  <a
                  class="mr-3 qa-ic-general-invoices-latest-invoices-card-pdf-download"
                  *ngIf="invoice.invoiceUrl.length > 0 "
                  [href]="invoice.invoiceUrl"
                  download
                  ngbTooltip="Download invoice PDF"
                  tooltipClass="bg-primary-tooltip"
                  [ngClass]="{'opacity-25 pe-none': isSalesView === true}"
                  ><span class="icon-df-download"></span
                ></a>

                <span
                  class="mr-3 text-muted"
                  *ngIf="invoice.invoiceUrl === '' "
                  ngbTooltip="No invoice PDF available"
                  href="javascript:void(0)"
                  ><span class="icon-df-download"></span
                ></span>
                </td>
              </tr>
          </tbody>
      </table>
      </div>
      </div>
</ng-template>

<ng-template #existingUiDisplay>
  <ng-container *ngIf="invoicesState$ | async as invoicesSt">
    <ng-container *ngIf="invoicesConfigState$ | async as invoicesConfigState">
      <ng-container *ngIf="invoicesSt.isLoading">
        <spinner fixed="true"></spinner>
      </ng-container>
  
      <div class="amadeus-direct-style">
        <div *ngIf="invoicesSt.loadingError; else table" class="request-error">
          <!-- <loading-error [message]="invoicesSt.loadingError"></loading-error> -->
        </div>
  
        <ng-template #table>
          <div
            *ngIf="invoicesConfigState.config?.disclaimer_message"
            class="disclaimer-message-invoices"
            style="padding-bottom: 25px;"
          >
            {{ invoicesConfigState.config?.disclaimer_message }}
          </div>
          <div class="invoices-table__container table-sortable__container">
            <table class="invoices-table table-sortable" *ngIf="invoicesSt.invoices.length > 0">
              <thead>
                <tr>
                  <td>
                    <a
                      class="sorting-link descending active"
                      data-sorting="created_at"
                      (click)="sort(invoicesSt.sorting)"
                      [ngClass]="invoicesSt.sorting === 'DESC' ? 'descending' : 'ascending'"
                      >{{ accountInvoicesTableDate }}</a
                    >
                  </td>
                  <td></td>
                </tr>
              </thead>
              <tbody class="table-sortable">
                <tr *ngFor="let invoice of invoicesSt.invoices">
                  <td>
                    <span *ngIf="invoice.fileDate">
                      {{ invoice.fileDate | yearMonth | reefDate: 'MMMM YY' }}
                    </span>
                  </td>
                  <td>
                    <a [href]="invoice.url" 
                    [ngClass]="{'opacity-25 pe-none': isSalesView === true}">{{ accountOrdersDetailsDownloadPdf }}</a>
                  </td>
                </tr>
              </tbody>
            </table>
  
            <p class="no-results"></p>
            <div class="pb-4" *ngIf="invoicesSt.invoices.length === 0" i18n="@@documents.accountInvoicesNoInvoices">
              There are no invoices
            </div>
  
            <div class="text-center"></div>
          </div>
        </ng-template>
      </div>
    </ng-container>
  </ng-container>  
</ng-template>
